import { useIntl } from 'react-intl';
import { useState } from 'react';

import NavLink from 'client/components/aria/NavLink/NavLink';
import Button from 'client/components/aria/Button/Button';

import { FEEDBACK_URL, HSG47_PAGE } from 'client/utils/routes/routeConstants';
import { DESKTOP } from 'client/utils/constants/GDS/js/devices';
import useDeviceType from 'client/utils/helpers/DeviceType/useDeviceType';

import styles from './PhaseBanner.module.scss';
import Icon from '@mdi/react';

import { mdiChevronUp, mdiChevronDown } from '@mdi/js';

const PhaseBanner = () => {
    const intl = useIntl();
    const [showFullText, setShowFullText] = useState(false);
    const deviceType = useDeviceType();

    const toggleFullText = () => {
        setShowFullText(!showFullText);
    };

    const message = intl.formatMessage({ id: 'phaseBanner.message' }, {
        link1: str => (
            <NavLink rel="noreferrer" to={FEEDBACK_URL}>{str}</NavLink>
        ),
        link2: str => (
            <NavLink rel="noreferrer" to={HSG47_PAGE}>{str}</NavLink>
        )
    });

    const isCollapsed = deviceType !== DESKTOP && !showFullText;

    return (
        <div className="govuk-phase-banner" id='phaseBanner' data-testid="phaseBanner" >
            <p className={[isCollapsed ? styles.phaseContainerCollapsed : '', 'govuk-phase-banner__content'].join(' ')}>
                <strong data-testid="phaseBanner.content.tag" className="govuk-tag govuk-phase-banner__content__tag">
                    {intl.formatMessage({ id: 'phaseBanner.title' })}
                </strong>
                { deviceType === DESKTOP
                    ? <span className="govuk-phase-banner__text" data-testid="phaseBanner.message">
                        {message}
                    </span>
                    : (
                        <>
                            <Button
                                className={styles.showMoreButton}
                                variant='info'
                                onPress={toggleFullText}
                                aria-expanded={showFullText}
                            >
                                <Icon path={showFullText ? mdiChevronUp : mdiChevronDown}
                                    role='img'
                                    aria-label={showFullText ? intl.formatMessage({ id: 'phaseBanner.close.label' }) : intl.formatMessage({ id: 'phaseBanner.open.label' })}
                                    aria-controls="mobilePhaseBanner"
                                    size={2}
                                    data-testid="phaseBannerMobileButton"
                                />
                            </Button>
                            <span className={showFullText ? styles.phaseExpanded : styles.phaseCollapsed} id="mobilePhaseBanner" data-testid="phaseBannerStyles">
                                {message}
                            </span>
                        </>
                    )}
            </p>
        </div>
    );
};

export default PhaseBanner;
